import gql from "graphql-tag";

export const MY_HR_VERIFY_2FA_TOTP_CODE = gql`
  mutation verify2faTotpCode($code: String!) {
    verify2faTotpCode(code: $code)
  }
`;
